'use strict';

var $ = require('js/sw-jquery/sw-jquery');
/**
 * Trigger jquery .trigger on an event.
 *
 * Usage:
 *
 *  data-sw-jquery-trigger="<event to trigger, default to click>" // See https://api.jquery.com/category/events/
 *
 *  data-sw-jquery-trigger-on="<event to trigger on, default to click>"
 *
 *  data-sw-jquery-selector="<selector to trigger the event on, defaults to this element>"
 *
 *  data-sw-jquery-selector-visible="true | false" // Set to true to make sure the element is :visible before triggering
 */

var TRIGGER_EVENT = 'data-sw-jquery-trigger';
var TRIGGER_ON = 'data-sw-jquery-trigger-on';
var TRIGGER_SELECTOR = 'data-sw-jquery-selector';
var TRIGGER_SELECTOR_VISIBLE = 'data-sw-jquery-selector-visible';


/**
 * Determine is an element is visible
 * jQuery/Chrome has issues with ":visible" (which also doesn't check for visibility)
 *
 * @param $el
 * @return {boolean|*}
 */
function isHidden($el) {
  return $el.css('display') === 'none' ||
    $el.css('visibility') === 'hidden' ||
    $el.width() === 0 ||
    $el.height() === 0 ||
    $el.is(':hidden');
}

module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-jquery-trigger]').each(function() {
    var $el = $(this);

    var triggerEvent = $el.attr(TRIGGER_EVENT) || 'click';
    // Default to click
    var triggerOn = $el.attr(TRIGGER_ON) || 'click';
    var selector = $el.attr(TRIGGER_SELECTOR);
    // Default to $el if no selector is provided
    var $selector = selector ? $(selector) : $el;
    if ($selector.length === 0) {
      return true;
    }
    var isVisibleCheck = $el.attr(TRIGGER_SELECTOR_VISIBLE) === 'true';
    $el.on(triggerOn, function() {
      if (isVisibleCheck && isHidden($selector)) {
        return;
      }
      var triggerEvents = triggerEvent.split(' ');
      $.each(triggerEvents, function(_, event) {
        $selector.trigger(event);
      });
    });

  });

};
